<template>
  <div>
    <a-card class="filter-data">
      <template slot="title">
        <span style="margin-right: 4px">并行的任务</span>
        <a-popover title="报表说明" placement="topLeft">
          <template slot="content">
            <p>时间: 开发完成时间</p>
            <p>描述: 任务的研发时间（开发中->已完成）的时间有重合的任务</p>
            <p>排序: 用户id排序正序(默认)</p>
          </template>
          <a-icon type="question-circle" />
        </a-popover>
      </template>
      <a-table :pagination="pagination" :columns="columns" size="middle" :data-source="taskList" :loading="loading" row-key="id" />
    </a-card>
  </div>
</template>
<script>
import { faultLevels } from '@/utils/dictionary';
import { getParallelTask } from '@/api/data/quality';
const columns = [
  {
    title: 'ID',
    dataIndex: 'id',
    key: 'id',
    width: '10%',
    ellipsis: true
  },
  {
    title: '任务名称',
    dataIndex: 'name',
    width: '15%',
    ellipsis: true
  },
  {
    title: '负责人',
    dataIndex: 'handler_role',
    width: '8%',
    align: 'center'
  },
  {
    title: '预估工时',
    width: '5%',
    ellipsis: true,
    dataIndex: 'point'
  },
  {
    title: '迭代',
    key: 'version_name',
    dataIndex: 'version_name',
    width: '15%',
    align: 'center'
  },
  {
    title: '实际开始时间',
    key: 'dev_start_time',
    dataIndex: 'dev_start_time',
    width: '15%',
    ellipsis: true,
    align: 'center'
  },
  {
    title: '实际结束时间',
    key: 'dev_end_time',
    dataIndex: 'dev_end_time',
    align: 'center',
    width: 90
  }
];

export default {
  props: {
    filterForm: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      loading: false,
      expand: false,
      faultLevels,
      taskList: [],
      projects: [],
      tagData: [],
      pagination: {
        size: 'large',
        total: 0,
        pageSize: 10, // 每页中显示10条数据
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '50', '100'], // 每页中显示的数据
        showTotal: total => `共 ${total} 条` // 分页中显示总的数据
      },
      faultInfo: {},
      modalVisible: false,
      faultId: null,
      tableData: [],
      columns
    };
  },
  watch: {
    filterForm() {
      this.getDiagramData();
      //   console.log(this.filterForm)
    },
    '$store.state.collapsed'() {
      setTimeout(() => {
        this.myChart.resize();
      }, 200);
    }
  },
  methods: {
    getDiagramData() {
      getParallelTask(this.filterForm).then(res => {
        this.taskList = res.data;
      });
    },

    onDetail(record) {
      this.$router.push({
        name: 'page:event:fault:detail',
        query: {
          faultId: record.id
        }
      });
    },

    toggle() {
      this.expand = !this.expand;
    },

    reset() {
      this.filterForm = {
        version_id: 1,
        user_group: 1
      };
      this.getDiagramData();
    }
  }
};
</script>

<style lang="less" scoped>
/deep/ .customer-filter {
  .ant-page-header {
    padding: 0;
  }
  margin-bottom: 16px;
  .ant-form-item {
    margin-bottom: 8px;
    display: flex;
    .ant-form-item-control-wrapper {
      flex: 1;
    }
  }
  .filter-right {
    float: right;
    text-align: right;
  }
}
.custom-link {
  color: rgba(0, 0, 0, 0.65);
}
.custom-link:hover {
  color: #1890ff;
}
</style>
